/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface V1ReferralReward
 */
export interface V1ReferralReward {
    /**
     * ABAC attribute granted, e.g. proSubscription
     */
    attribute: string
    /**
     *
     */
    durationDays: number
    /**
     *
     */
    beneficiary: V1ReferralRewardBeneficiaryEnum
    /**
     * At most this many rewards per user; 0 = no cap
     */
    capPerUser?: number
}

/**
 * @export
 */
export const V1ReferralRewardBeneficiaryEnum = {
    Referrer: 'referrer',
    Referee: 'referee'
} as const
export type V1ReferralRewardBeneficiaryEnum =
    (typeof V1ReferralRewardBeneficiaryEnum)[keyof typeof V1ReferralRewardBeneficiaryEnum]

/**
 * Check if a given object implements the V1ReferralReward interface.
 */
export function instanceOfV1ReferralReward(
    value: object
): value is V1ReferralReward {
    if (!('attribute' in value) || value['attribute'] === undefined)
        return false
    if (!('durationDays' in value) || value['durationDays'] === undefined)
        return false
    if (!('beneficiary' in value) || value['beneficiary'] === undefined)
        return false
    return true
}

export function V1ReferralRewardFromJSON(json: any): V1ReferralReward {
    return V1ReferralRewardFromJSONTyped(json, false)
}

export function V1ReferralRewardFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1ReferralReward {
    if (json == null) {
        return json
    }
    return {
        attribute: json['attribute'],
        durationDays: json['durationDays'],
        beneficiary: json['beneficiary'],
        capPerUser: json['capPerUser'] == null ? undefined : json['capPerUser']
    }
}

export function V1ReferralRewardToJSON(json: any): V1ReferralReward {
    return V1ReferralRewardToJSONTyped(json, false)
}

export function V1ReferralRewardToJSONTyped(
    value?: V1ReferralReward | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        attribute: value['attribute'],
        durationDays: value['durationDays'],
        beneficiary: value['beneficiary'],
        capPerUser: value['capPerUser']
    }
}
